import { ChannelkartNetworkGet, ChannelkartNetworkPut } from "./networkService";

export async function getAllCouponData(){
    const response = await ChannelkartNetworkGet(`/v1/query/coupon_management`);
    return response;
}

export async function updateCouponInfo(requestBody: any){
    const response = await ChannelkartNetworkPut(`/offers/updateDate`, requestBody);
    return response;
}